import styles from './style.postcss';

import React from 'react';
import PropTypes from 'prop-types';
import { connect, PageCard, ColourLabel, Grid } from 'omni-common-ui';
import { actions as RAv2CicActions, accessors as RAv2CicAccessors } from 'data/RAv2Cic';
import { bindActionCreators } from 'redux';

/**
 * CoveredInClassRAv2 Component
 *
 * Displays Reading Academy v2.0 Covered in Class content including
 * Story Title, Lesson Focus, and Vocabulary sections.
 */
class CoveredInClassRAv2 extends React.Component {
  static propTypes = {
    params: PropTypes.shape({
      groupId: PropTypes.string.isRequired,
      sessionPlanId: PropTypes.string,
      unitId: PropTypes.string,
    }).isRequired,
    rav2Cic: PropTypes.object,
    fetchRAv2CicIfNeeded: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this._fetchData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.sessionPlanId !== this.props.params.sessionPlanId) {
      this._fetchData(nextProps);
    }
  }

  _fetchData(props = this.props) {
    const { sessionPlanId } = props.params;
    if (sessionPlanId) {
      props.fetchRAv2CicIfNeeded(sessionPlanId);
    }
  }

  _renderSection(label, content) {
    if (! content) return null;
    return (
      <div className={styles.section}>
        <PageCard>
          <PageCard.Heading text={label} />
          <PageCard.Content>
            <div className={styles.sectionContent}>{content}</div>
          </PageCard.Content>
        </PageCard>
      </div>
    );
  }

  render() {
    const { rav2Cic } = this.props;

    if (! rav2Cic) {
      return (
        <Grid outerMargin>
          <Grid.Group>
            <div className={styles.empty}>No content available for this session.</div>
          </Grid.Group>
        </Grid>
      );
    }

    return (
      <Grid outerMargin>
        <Grid.Group>
          <div className={styles.header}>
            <ColourLabel text="published" colour="#74d17f" />
          </div>
          {this._renderSection('Story Title', rav2Cic.storyTitle)}
          {this._renderSection('Lesson Focus', rav2Cic.lessonFocus)}
          {this._renderSection('Vocabulary', rav2Cic.vocabulary)}
        </Grid.Group>
      </Grid>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { sessionPlanId } = ownProps.params;
  return {
    rav2Cic: sessionPlanId ? RAv2CicAccessors.getRAv2Cic(state, sessionPlanId) : null,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchRAv2CicIfNeeded: RAv2CicActions.fetchRAv2CicIfNeeded,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CoveredInClassRAv2);



// WEBPACK FOOTER //
// ./containers/Group/CoveredInClassRAv2/component.jsx